// extracted by mini-css-extract-plugin
module.exports = {"content":"materials_content__3px6x","center":"materials_center__2KBcU"};